import { Box, Button, Stack, Typography } from '@mui/material'
import Iconify from '../../../components/Iconify'
import React from 'react'
import { useTheme } from '@mui/material/styles'
import background from '../../../assets/images/logo-dark-contact.png'
import { showMessage } from '../../../redux/reducers/snackbar/snackbar.actions'
import { useAppDispatch } from '../../../redux/hooks'
import { useTranslation } from 'react-i18next'

export default function ContactUs () {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '3px solid #000',
    boxShadow: 30,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 5,
    paddingRight: 5,
    widthMax: 800,
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '40%',
    borderRadius: 4
  }

  const handleCopyEmailLink = () => {
    navigator.clipboard
      .writeText('suporte@deltaworkfit.com')
      .then(() => {
        dispatch(showMessage({ message: `${t('contact.copyEmailSuccess')}` }))
      })
      .catch(() => {
        dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
      })
  }

  return (
    <Stack sx={style}>
      <Stack>
        <Typography variant="h2">{t('contact.titleCard')}</Typography>
        <Stack mt={2}>
          <Typography color={theme.palette.primary.main}>
            {t('contact.subtitle1')}
          </Typography>
          <Typography color={theme.palette.primary.main}>
            {t('contact.subtitle2')}
          </Typography>
        </Stack>
      </Stack>
      <Stack mt={2}>
        <Box>
          <Button variant="text"
            onClick={() => window.open('https://wa.me/message/6DDWURWTYO2EG1', '_blank', 'noopener')}>
            <Iconify icon="logos:whatsapp-icon" width={17} height={17}/>&nbsp;&nbsp;WHATSAPP
          </Button>
        </Box>
        <Box>
          <Button variant="text"
            onClick={() => window.open('mailto:suporte@deltaworkfit.com', '_blank', 'noopener')}>
            <Iconify icon="emojione-v1:e-mail" width={17} height={17}/>&nbsp;&nbsp;suporte@deltaworkfit.com
          </Button>
        </Box>
      </Stack>
      <Stack mt={4} flexDirection="row" justifyContent="space-between">
        <Stack alignItems="start">
          <Button variant="contained" onClick={handleCopyEmailLink}>COPY EMAIL</Button>
        </Stack>
        <Stack alignItems="end">
          <Button variant="text"
            onClick={() => window.open('https://www.instagram.com/deltaworkfit/', '_blank', 'noopener')}>
            <Iconify icon="skill-icons:instagram" width={25} height={25}/>
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}
